document.addEventListener('click', (event) => {
  // Check if the clicked element (or one of its parents) is the button
  const loadMoreButton = event.target.closest('#load-more-button');

  // If the click wasn't on the button, do nothing
  if (!loadMoreButton) {
    return;
  }

  const hiddenImages = document.querySelectorAll('.gallery_images');
  hiddenImages.forEach(image => {
    image.hidden = false;
  });

  const loadMoreContainer = document.getElementById('load-more-container');
  if (loadMoreContainer) {
    loadMoreContainer.hidden = true;
  }
});